import { mapGetters } from 'vuex';

export default {
    name: 'agentTips',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb'])
    }
};